import type { SearchPageView } from "./_types";
import logEvent from "./logEvent";
import type { LoggingEvent } from "./logEvent";

/**
 *
 * @param props This object contains
 */

const searchPageView = ({ type, category, place, portfolio_id, latitude, longitude }: SearchPageView) => {
  // UA
  // This is handled by the default pageView

  // Tag Manager
  let layerUpdate: SearchPageView = { event: "search_page_view" };

  if (type) layerUpdate.type = type;
  if (place) layerUpdate.place = place;
  if (category) layerUpdate.category = category;
  if (portfolio_id) layerUpdate.portfolio_id = portfolio_id;
  if (latitude) layerUpdate.latitude = latitude;
  if (longitude) layerUpdate.longitude = longitude;

  logEvent(layerUpdate);
};

export default searchPageView;
